import React from 'react';

const SORT_CARET_SVG_MARKUP = `<svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none"><path d="M0.751953 10.3052L3.66862 13.2218L6.58529 10.3052" stroke="#94A3B8" stroke-width="1.50284" stroke-linecap="round" stroke-linejoin="round"/><path d="M0.751953 3.66813L3.66862 0.751465L6.58529 3.66813" stroke="#94A3B8" stroke-width="1.50284" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

export const SORT_CARET_DATA_URI = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(SORT_CARET_SVG_MARKUP)}`;

export const SortCaretIcon = ({ stroke = '#94A3B8', width, height, className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 9 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M0.751953 10.3052L3.66862 13.2218L6.58529 10.3052"
                stroke={stroke}
                strokeWidth="1.50284"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M0.751953 3.66813L3.66862 0.751465L6.58529 3.66813"
                stroke={stroke}
                strokeWidth="1.50284"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};